// Import data lists for consistency
import genderValues from '../data/event/genderValues';
import sectorValues from '../data/event/sectorValues';
import culturalCompetenceValues from '../data/event/culturalCompetenceValues';
import workPermitValues from '../data/event/workPermitValues';
import communicationValues from '../data/event/communicationValues';
import professionValues from '../data/event/professionValues';
import provinceValues from '../data/apply/provinceValues';

// Communication Types
export const COMMUNICATION_TYPES = {
  EMAIL: 'Email',
  SMS: 'SMS'
};

// Gender Options
export const GENDER_OPTIONS = {
  FEMALE: 'Female',
  MALE: 'Male',
  OTHER: 'Other'
};

// Sector Options
export const SECTOR_OPTIONS = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
  UNEMPLOYED: 'None'
};

// Cultural Competence Options
export const CULTURAL_COMPETENCE_OPTIONS = {
  YES: 'Yes',
  NO: 'No'
};

// Work Permit Options
export const WORK_PERMIT_OPTIONS = {
  YES: 'Yes',
  NO: 'No'
};

// Application Status Options
export const APPLICATION_STATUS = {
  INCOMPLETE_MEMBER: 'INCOMPLETE_MEMBER',
  PENDING_VERIFICATION_MEMBER: 'PENDING_VERIFICATION_MEMBER',
  PENDING_APPROVAL_MEMBER: 'PENDING_APPROVAL_MEMBER',
  APPROVED_MEMBER: 'APPROVED_MEMBER'
};

// ID Type Options
export const ID_TYPE_OPTIONS = {
  ID: 'ID',
  PASSPORT: 'Passport'
};

export const PAYMENT_METHOD = {
  ONLINE: 'ONLINE',
  MANUAL: 'MANUAL'
};

export const PAYMENT_STATUS = {
  NOT_PAID: 'NOT_PAID',
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  PART_PAID: 'PART_PAID'
};

// Province Options
export const PROVINCE_OPTIONS = {
  BULAWAYO_METROPOLITAN: 'Bulawayo Metropolitan',
  HARARE_METROPOLITAN: 'Harare Metropolitan',
  MANICALAND: 'Manicaland',
  MASVINGO: 'Masvingo',
  MIDLANDS: 'Midlands',
  MASHONALAND_WEST: 'Mashonaland West',
  MASHONALAND_EAST: 'Mashonaland East',
  MASHONALAND_CENTRAL: 'Mashonaland Central',
  MATEBELELAND_SOUTH: 'Matebeleland South',
  MATEBELELAND_NORTH: 'Matebeleland North'
};

// Renewal Status Options
export const RENEWAL_STATUS = {
  RENEWED: 'RENEWED',
  PROCESSING: 'PROCESSING',
  NOT_RENEWED: 'NOT_RENEWED',
  EXPIRED: 'EXPIRED',
  NOT_STARTED: 'NOT_STARTED',
  RENEWAL_PENDING_VERIFICATION: 'RENEWAL_PENDING_VERIFICATION',
  RENEWAL_PENDING_APPROVAL: 'RENEWAL_PENDING_APPROVAL'
};

// Profession Options (simplified key names)
export const PROFESSION_OPTIONS = {
  ARTS_THERAPIST: 'AT-Arts Therapist',
  AUDIOLOGIST: 'AUD-Audiology',
  BIOKINETICIST: 'BK-Biokineticists',
  CHIROPODIST: 'CH-Chiropodists',
  OCCUPATIONAL_THERAPIST: 'OT-Occupational Therapy',
  ORTHOPAEDIST: 'OG-Orthopaedics',
  MAINTENANCE_REGISTER: 'MR-Maintenance Register',
  MASSAGE_THERAPIST: 'MT-Massage Therapists',
  NEUROMUSCULAR_THERAPIST: 'NR-Neuromuscular Therapist',
  OCCUPATIONAL_THERAPIST_TRAINEE: 'OTT-Occupational Therapists Trainee',
  PHYSIOTHERAPIST: 'PH-Physiotherapy',
  PHYSIOTHERAPIST_TRAINEE: 'PHT-Physiotherapist Trainee',
  PODIATIST: 'PD-Podiatry',
  REHAB_TECHNICIAN_TRAINEE: 'RTR-Rehab Technicians Trainee',
  REHABILITATION_TECHNICIAN: 'RT-Rehabilitation Technician',
  SPEECH_PATHOLOGIST: 'SP-Speech Pathology',
  SPEECH_THERAPIST: 'ST-Speech Therapist',
  SPORTS_SCIENTIST: 'SPS-Sports Scientist',
  SPORTS_THERAPIST: 'SPT-Sports Therapists',
  SPEECH_AND_AUDIOLOGY_THERAPIST: 'STA-Speech and Audiology Therapist',
  WORK_REHABILITATION: 'WR-Work Rehabilitation'
};

// Re-export data lists for easy access (backward compatibility)
export const GENDER_VALUES = genderValues;
export const SECTOR_VALUES = sectorValues;
export const CULTURAL_COMPETENCE_VALUES = culturalCompetenceValues;
export const WORK_PERMIT_VALUES = workPermitValues;
export const COMMUNICATION_VALUES = communicationValues;
export const PROFESSION_VALUES = professionValues;
export const PROVINCE_VALUES = provinceValues;
